webpackJsonp([166349362330929],{

/***/ 1139:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"slug":"/en/corporate_program/","langKey":"en"}}

/***/ })

});


// WEBPACK FOOTER //
// path---en-corporate-program-3074a4a64b033c045df5.js